import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { directiveEntry } from "./directives";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DirectiveHelp',
    props: {
        directive: null,
        mode: null
    },
    setup(__props) {
        const props = __props;
        const entry = computed(() => directiveEntry(props.directive, props.mode));
        return { __sfc: true, props, entry };
    }
});
